/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum exportTypeEnum {
    WORD = 'Word',
    EXCEL = 'Excel',
    POWER_POINT = 'PowerPoint',
}